/* Herbal Talents - Versand: Leiste bis zum kostenlosen Versand + Versandkostenrechner
   Rechner nutzt die Shopify Cart API (prepare_shipping_rates / async_shipping_rates),
   die Preise kommen also immer live aus den Versandeinstellungen in Shopify. */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var NAMES = { AT: 'Austria', BE: 'Belgium', CH: 'Switzerland', CZ: 'Czech Republic', DE: 'Germany', DK: 'Denmark', ES: 'Spain', FR: 'France', GB: 'United Kingdom', IT: 'Italy', LU: 'Luxembourg', NL: 'Netherlands', PL: 'Poland', PT: 'Portugal', SE: 'Sweden' };

  function cur() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'; }
  function rate() { var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate); return r > 0 ? r : 1; }
  function money(amount) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: cur() }).format(amount); }
    catch (e) { return amount.toFixed(2) + ' ' + cur(); }
  }
  function parseMap(str) {
    var map = {};
    (str || '').split(/[;\n]/).forEach(function (line) {
      var p = line.split('=');
      if (p.length === 2) { var v = parseFloat(p[1].replace(',', '.')); if (!isNaN(v)) map[p[0].trim().toUpperCase()] = v; }
    });
    return map;
  }

  /* ---- Leiste ---- */
  function initBars(scope) {
    (scope || document).querySelectorAll('[data-ht-ship-bar]').forEach(function (bar) {
      var key = bar.getAttribute('data-total') + '|' + bar.getAttribute('data-threshold-eur');
      if (bar.getAttribute('data-ht-ready') === key) return;
      bar.setAttribute('data-ht-ready', key);
      var total = parseInt(bar.getAttribute('data-total'), 10) / 100;
      var th = parseFloat(bar.getAttribute('data-threshold-eur')) * rate();
      var text = bar.querySelector('[data-ht-ship-text]');
      var fill = bar.querySelector('[data-ht-ship-fill]');
      if (!(th > 0)) { bar.hidden = true; return; }
      var pct = Math.max(0, Math.min(100, (total / th) * 100));
      fill.style.width = pct + '%';
      if (total >= th) {
        bar.classList.add('is-done');
        text.textContent = bar.getAttribute('data-done');
      } else {
        bar.classList.remove('is-done');
        var tpl = bar.getAttribute('data-text') || 'Nur noch [betrag] bis zum kostenlosen Versand';
        var parts = tpl.split('[betrag]');
        text.textContent = '';
        text.appendChild(document.createTextNode(parts[0] || ''));
        var b = document.createElement('strong'); b.textContent = money(th - total); text.appendChild(b);
        text.appendChild(document.createTextNode(parts[1] || ''));
      }
    });
  }

  /* ---- Rechner ---- */
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function params(country, zip) {
    var p = new URLSearchParams();
    p.append('shipping_address[country]', NAMES[country] || country);
    p.append('shipping_address[zip]', zip || '');
    p.append('shipping_address[province]', '');
    return p.toString();
  }
  function getRates(country, zip) {
    var q = params(country, zip);
    return fetch(ROOT + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST' })
      .then(function (r) {
        if (r.status === 422) return r.json().then(function (j) { throw { fields: j }; });
        return poll(q, 0);
      });
  }
  function poll(q, n) {
    return fetch(ROOT + 'cart/async_shipping_rates.json?' + q).then(function (r) {
      if (r.status === 422) return r.json().then(function (j) { throw { fields: j }; });
      return r.json().then(function (j) {
        if (j && j.shipping_rates) return j.shipping_rates;
        if (n > 14) throw { timeout: true };
        return sleep(600).then(function () { return poll(q, n + 1); });
      });
    });
  }
  function calc(box) {
    var sel = box.querySelector('[data-ht-ship-country]');
    var zip = box.querySelector('[data-ht-ship-zip]');
    var out = box.querySelector('[data-ht-ship-result]');
    var btn = box.querySelector('[data-ht-ship-go]');
    var country = sel.value, countryName = sel.options[sel.selectedIndex].text;
    var map = parseMap(box.getAttribute('data-map'));
    var th = (map[country] != null ? map[country] : parseFloat(box.getAttribute('data-default'))) * rate();
    out.innerHTML = '<p class="ht-ship-calc__wait">Versandkosten werden berechnet …</p>';
    btn.setAttribute('aria-busy', 'true');
    getRates(country, zip.value.trim()).then(function (rates) {
      btn.removeAttribute('aria-busy');
      var html = '';
      if (!rates.length) {
        html = '<p class="ht-ship-calc__err">Für ' + countryName + ' ist für diesen Warenkorb kein Versand hinterlegt.</p>';
      } else {
        html = '<ul class="ht-ship-calc__list">' + rates.map(function (r) {
          var p = parseFloat(r.price);
          return '<li><span>' + (r.presentment_name || r.name) + '</span><b>' + (p === 0 ? 'Kostenlos' : money(p)) + '</b></li>';
        }).join('') + '</ul>';
      }
      if (th > 0) html += '<p class="ht-ship-calc__free">Kostenloser Versand nach ' + countryName + ' ab <b>' + money(th) + '</b></p>';
      out.innerHTML = html;
    }).catch(function (err) {
      btn.removeAttribute('aria-busy');
      if (err && err.fields && (err.fields.zip || (err.fields.error && /zip|post/i.test(String(err.fields.error))))) {
        out.innerHTML = '<p class="ht-ship-calc__err">Für ' + countryName + ' brauchen wir die Postleitzahl. Bitte trag sie ein und klick erneut auf Berechnen.</p>';
        zip.focus();
      } else {
        out.innerHTML = '<p class="ht-ship-calc__err">Die Versandkosten konnten gerade nicht berechnet werden. Bitte versuch es noch einmal.</p>';
      }
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ht-ship-go]');
    if (b) { e.preventDefault(); calc(b.closest('[data-ht-ship-calc]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-ht-ship-zip]')) { e.preventDefault(); calc(e.target.closest('[data-ht-ship-calc]')); }
  });

  function start() {
    initBars(document);
    var mo = new MutationObserver(function () { initBars(document); });
    ['CartDrawer', 'main-cart-footer', 'main-cart-items'].forEach(function (id) {
      var el = document.getElementById(id) || document.querySelector('[id*="' + id + '"]');
      if (el) mo.observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
